import React from "react";
import { Navigation, Footer } from "@servicepro/jobsite-components";
import { SEOHead } from "../components/seo-head";
import siteData from "virtual:site-data";

// Styled inline rather than with Tailwind utilities: the stylesheet is
// prebuilt from jobsite-components sources, so utility classes used only on
// this page are not in the shipped CSS.
const headingStyle: React.CSSProperties = {
  fontFamily: "var(--jobsite-font-heading)",
  fontWeight: "var(--jobsite-font-weight-heading)" as React.CSSProperties["fontWeight"],
  fontSize: "clamp(2.25rem, 6vw, 3.5rem)",
  lineHeight: 1.1,
  color: "var(--jobsite-foreground)",
  margin: "0 0 16px",
};

const bodyStyle: React.CSSProperties = {
  fontFamily: "var(--jobsite-font-body)",
  fontSize: "1.125rem",
  lineHeight: 1.6,
  color: "var(--jobsite-muted-foreground)",
  margin: "0 auto 32px",
  maxWidth: "44ch",
};

const ctaStyle: React.CSSProperties = {
  display: "inline-block",
  backgroundColor: "var(--jobsite-accent)",
  color: "var(--jobsite-accent-foreground)",
  fontFamily: "var(--jobsite-font-body)",
  fontWeight: "var(--jobsite-button-weight)" as React.CSSProperties["fontWeight"],
  textTransform: "var(--jobsite-button-transform)" as React.CSSProperties["textTransform"],
  letterSpacing: "var(--jobsite-button-tracking)",
  borderRadius: "var(--jobsite-radius)",
  padding: "14px 28px",
  fontSize: "1rem",
  textDecoration: "none",
};

export const NotFound: React.FC = () => {
  const { navigationConfig, footerConfig, seoMetadata } = siteData;

  return (
    <>
      <SEOHead
        metadata={{
          title: seoMetadata?.defaultTitle
            ? `Page not found | ${seoMetadata.defaultTitle}`
            : "Page not found",
          description: "The page you are looking for could not be found.",
          noindex: true,
          nofollow: true,
          robots: {
            index: false,
            follow: false,
          },
        }}
        faviconUrl={seoMetadata?.faviconUrl}
      />

      <div
        className="jobsite-container"
        style={{ minHeight: "100vh", display: "flex", flexDirection: "column" }}
      >
        {navigationConfig && <Navigation {...navigationConfig} />}

        <main
          style={{
            flex: 1,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "96px 24px",
            textAlign: "center",
          }}
        >
          <div style={{ maxWidth: "560px" }}>
            <p
              style={{
                fontFamily: "var(--jobsite-font-body)",
                fontWeight: 600,
                fontSize: "0.875rem",
                letterSpacing: "0.08em",
                color: "var(--jobsite-accent)",
                margin: "0 0 16px",
              }}
            >
              404
            </p>
            <h1 style={headingStyle}>Page not found</h1>
            <p style={bodyStyle}>
              This page doesn&rsquo;t exist or may have moved.
            </p>
            <a href="/" style={ctaStyle}>
              Back to home
            </a>
          </div>
        </main>

        {footerConfig && <Footer {...footerConfig} />}
      </div>
    </>
  );
};
